export default (that) => [
  {
    text: that.$l('INDEX.btn_tips_view') || '查看',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('INDEX.btn_tips_edit') || '编辑',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ colorStatus }) => !['A', 'R'].includes(colorStatus),
  },
  {
    text: that.$l('INDEX.btn_tips_del') || '删除',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ colorStatus }) => !['A', 'R'].includes(colorStatus),
  },
  {
    text: that.$l('menu_text_submit') || '提交审核',
    icon: 'el-icon-s-check',
    menuType: 'submit',
    divided: true,
    allow: 'S',
    disabled: ({ colorStatus }) => !['A', 'R'].includes(colorStatus),
  },
  {
    text: that.$l('menu_text_review') || '审核通过',
    icon: 'el-icon-check',
    menuType: 'review',
    allow: 'Y',
    disabled: ({ colorStatus }) => colorStatus !== 'S',
  },
  {
    text: that.$l('menu_text_reject') || '审核驳回',
    icon: 'el-icon-close',
    menuType: 'reject',
    allow: 'R',
    disabled: ({ colorStatus }) => colorStatus !== 'S',
  },
]
